import { FieldHint, FieldLabel, TextArea, TextInput } from "@amber/ui";
import { DuplicateNotice } from "./DuplicateNotice";
import { Languages } from "./Languages";
import type { CreateFlow } from "./useCreateProfile";

export function ManualStep({ flow }: { flow: CreateFlow }) {
  const { different } = flow;
  return (
    <>
      <div className="flex flex-col gap-2">
        {flow.duplicates.map((d) => (
          <DuplicateNotice
            key={d.id}
            duplicate={d}
            decided={different.includes(d.id)}
            onDifferent={() => {
              flow.setDifferent([...different, d.id]);
            }}
            onComplete={null}
          />
        ))}
      </div>
      <div className="mt-3">
        <FieldLabel htmlFor="manual-name" required>
          Display name
        </FieldLabel>
        <TextInput
          id="manual-name"
          value={flow.displayName}
          aria-invalid={flow.submitted && flow.displayName.trim().length === 0 ? true : undefined}
          onChange={(e) => {
            flow.setDisplayName(e.target.value);
          }}
        />
      </div>
      <Languages value={flow.languages} onChange={flow.setLanguages} invalid={flow.languagesInvalid} />
      <div className="mt-3">
        <FieldLabel htmlFor="manual-role" optional="optional">
          Current role
        </FieldLabel>
        <TextInput
          id="manual-role"
          value={flow.role}
          onChange={(e) => {
            flow.setRole(e.target.value);
          }}
        />
      </div>
      <div className="mt-3">
        <FieldLabel htmlFor="manual-rationale" required>
          Rationale
        </FieldLabel>
        <TextArea
          id="manual-rationale"
          value={flow.rationale}
          aria-invalid={flow.rationaleInvalid ? true : undefined}
          placeholder="e.g. Newly appointed minister; speaks often on budget policy"
          onChange={(e) => {
            flow.setRationale(e.target.value);
          }}
        />
        {flow.rationaleInvalid ? (
          <p className="m-0 mt-1.5 text-md text-attention">Say why this person should be tracked</p>
        ) : null}
      </div>
      <FieldHint>Birth date, aliases and accounts stay empty rather than guessed; add accounts later.</FieldHint>
    </>
  );
}
